module.exports = __webpack_public_path__ + "img/fiery.0dc45f70.svg";